import UserInfo from "../../types/UserInfo";

const NavBarAccountSectionHeader: React.FC<{userInfo: UserInfo}> = ({
	userInfo,
}) => {
	const name = userInfo.first_name ?? userInfo.display_name;
	return (
		<div className="bg-green-800 px-8 py-4 text-white">
			<span className="text-pretty pr-2 font-serif text-h4">
				{name ? `Hello, ${name}!` : "Welcome!"}
			</span>
		</div>
	);
};

export default NavBarAccountSectionHeader;
